import { useCallback } from 'react';
import { posthogTrackEvent, KnowledgeEvents } from '@/assets/posthog';

export const useKnowledgeTracking = () => {
  const trackArticleViewed = useCallback((articleId: string, articleTitle?: string) => {
    posthogTrackEvent({
      event: KnowledgeEvents.ARTICLE_VIEWED,
      properties: {
        articleId,
        articleTitle,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackArticleSearched = useCallback((searchTerm: string, resultsCount?: number) => {
    posthogTrackEvent({
      event: KnowledgeEvents.ARTICLE_SEARCHED,
      properties: {
        searchTerm,
        resultsCount,
        searchLength: searchTerm.length,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackKnowledgeGapViewed = useCallback((gapId: string, gapType?: string) => {
    posthogTrackEvent({
      event: KnowledgeEvents.KNOWLEDGE_GAP_VIEWED,
      properties: {
        gapId,
        gapType,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackKnowledgeGapSearched = useCallback((searchTerm: string, resultsCount?: number) => {
    posthogTrackEvent({
      event: KnowledgeEvents.KNOWLEDGE_GAP_SEARCHED,
      properties: {
        searchTerm,
        resultsCount,
        searchLength: searchTerm.length,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackFilterApplied = useCallback((filterType: string, filterValue: any) => {
    posthogTrackEvent({
      event: KnowledgeEvents.FILTER_APPLIED,
      properties: {
        filterType,
        filterValue,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackDateRangeChanged = useCallback((dateRange: { from: string; to: string }) => {
    posthogTrackEvent({
      event: KnowledgeEvents.DATE_RANGE_CHANGED,
      properties: {
        dateFrom: dateRange.from,
        dateTo: dateRange.to,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  return {
    trackArticleViewed,
    trackArticleSearched,
    trackKnowledgeGapViewed,
    trackKnowledgeGapSearched,
    trackFilterApplied,
    trackDateRangeChanged,
  };
};